
import {
  computed, defineComponent, onMounted, ref,
} from 'vue';
import { useRouter } from 'vue-router/composables';

import store from '~store';

export default defineComponent({
  props: {
    /* Language as string like "de_DE", "en_GB" or "fr_CH" */
    language: {
      type: String,
      default: null,
    },
    /* Amount to pay as number like 500 */
    amount: {
      type: Number,
      default: null,
    },
    /* Currency as string like "EUR" */
    currency: {
      type: String,
      default: null,
    },
    /* Redeem value. The resulting amount of the paid up voucher for example 2000 */
    redeemValue: {
      type: Number,
      default: null,
    },
    /* Voucher token as long, dot-separated base64 String. */
    voucherToken: {
      type: String,
      default: null,
    },
    /* ID of the shop as a Number like 62 or 1105 */
    shopId: {
      type: Number,
      default: null,
    },
    /* Ledger Currency as a string like "EUR" */
    ledgerCurrency: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const router = useRouter();

    const loading = ref(false);

    const returnUrl = computed((): string => {
      const baseUrl = `https://${window.location.host}`;
      const path = router.resolve({
        name: 'amazonPayReturn',
        query: {
          shopId: String(props.shopId),
          amount: String(props.amount),
          currency: String(props.currency),
        },
      }).href;

      return `${baseUrl}${path}`;
    });

    onMounted(() => {
      // show loading overlay
      loading.value = true;

      // inject amazon pay script into head tag
      const script = document.createElement('script');
      script.setAttribute('src', 'https://static-eu.payments-amazon.com/checkout.js');
      script.setAttribute('async', 'async');
      // script.setAttribute(' type', 'text/plain')
      script.setAttribute('data-cookiefirst-category', 'necessary');
      script.addEventListener('load', () => {
        store
          .dispatch('initAmazonPay', {
            amount: props.amount,
            returnUrl: returnUrl.value,
            redeemValue: props.redeemValue,
            ledgerCurrency: props.ledgerCurrency,
            checkoutLanguage: props.language,
          })
          .then(() => {
            // hide loader
            loading.value = false;
          });
      });
      document.querySelector?.('head')?.append(script);
    });

    return {
      loading,
    };
  },
});
